import { render, staticRenderFns } from "./Theme4ContactComponent.vue?vue&type=template&id=7834bf11&scoped=true&"
import script from "./Theme4ContactComponent.vue?vue&type=script&lang=js&"
export * from "./Theme4ContactComponent.vue?vue&type=script&lang=js&"
import style0 from "./Theme4ContactComponent.vue?vue&type=style&index=0&id=7834bf11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7834bf11",
  null
  
)

export default component.exports